
export enum ZoneGeographiqueEnum {
  EMPTY,
  D_01,
  D_02,
  D_03,
  D_04,
  D_05,
  D_06,
  D_07,
  D_08,
  D_09,
  D_10,
  D_11,
  D_12,
  D_13,
  D_14,
  D_15,
  D_16,
  D_17,
  D_18,
  D_19,
  D_2A,
  D_2B,
  D_21,
  D_22,
  D_23,
  D_24,
  D_25,
  D_26,
  D_27,
  D_28,
  D_29,
  D_30,
  D_31,
  D_32,
  D_33,
  D_34,
  D_35,
  D_36,
  D_37,
  D_38,
  D_39,
  D_40,
  D_41,
  D_42,
  D_43,
  D_44,
  D_45,
  D_46,
  D_47,
  D_48,
  D_49,
  D_50,
  D_51,
  D_52,
  D_53,
  D_54,
  D_55,
  D_56,
  D_57,
  D_58,
  D_59,
  D_60,
  D_61,
  D_62,
  D_63,
  D_64,
  D_65,
  D_66,
  D_67,
  D_68,
  D_69,
  D_70,
  D_71,
  D_72,
  D_73,
  D_74,
  D_75,
  D_76,
  D_77,
  D_78,
  D_79,
  D_80,
  D_81,
  D_82,
  D_83,
  D_84,
  D_85,
  D_86,
  D_87,
  D_88,
  D_89,
  D_90,
  D_91,
  D_92,
  D_93,
  D_94,
  D_95,
  D_971,
  D_972,
  D_973,
  D_974,
  D_976,
}


export class DepartementMapper {

  private static readonly INTITULES: Record<string, string> = {
    EMPTY: 'Pas de departement',
    D_01: '01 (Ain)',
    D_02: '02 (Aisne)',
    D_03: '03 (Allier)',
    D_04: '04 (Alpes-de-Haute-Provence)',
    D_05: '05 (Hautes-alpes)',
    D_06: '06 (Alpes-maritimes)',
    D_07: '07 (Ardèche)',
    D_08: '08 (Ardennes)',
    D_09: '09 (Ariège)',
    D_10: '10 (Aube)',
    D_11: '11 (Aude)',
    D_12: '12 (Aveyron)',
    D_13: '13 (Bouches-du-Rhône)',
    D_14: '14 (Calvados)',
    D_15: '15 (Cantal)',
    D_16: '16 (Charente)',
    D_17: '17 (Charente-maritime)',
    D_18: '18 (Cher)',
    D_19: '19 (Corrèze)',
    D_2A: '20A Corse-du-sud',
    D_2B: '20B Haute-Corse',
    D_21: "21 (Côte-d'Or)",
    D_22: "22 (Côtes-d'Armor)",
    D_23: '23 (Creuse)',
    D_24: '24 (Dordogne)',
    D_25: '25 (Doubs)',
    D_26: '26 (Drôme)',
    D_27: '27 (Eure)',
    D_28: '28 (Eure-et-loir)',
    D_29: '29 (Finistère)',
    D_30: '30 (Gard)',
    D_31: '31 (Haute-garonne)',
    D_32: '32 (Gers)',
    D_33: '33 (Gironde)',
    D_34: '34 (Hérault)',
    D_35: '35 (Ille-et-vilaine)',
    D_36: '36 (Indre)',
    D_37: '37 (Indre-et-loire)',
    D_38: '38 (Isère)',
    D_39: '39 (Jura)',
    D_40: '40 (Landes)',
    D_41: '41 (Loir-et-cher)',
    D_42: '42 (Loire)',
    D_43: '43 (Haute-loire)',
    D_44: '44 (Loire-atlantique)',
    D_45: '45 (Loiret)',
    D_46: '46 (Lot)',
    D_47: '47 (Lot-et-garonne)',
    D_48: '48 (Lozère)',
    D_49: '49 (Maine-et-loire)',
    D_50: '50 (Manche)',
    D_51: '51 (Marne)',
    D_52: '52 (Haute-marne)',
    D_53: '53 (Mayenne)',
    D_54: '54 (Meurthe-et-moselle)',
    D_55: '55 (Meuse)',
    D_56: '56 (Morbihan)',
    D_57: '57 (Moselle)',
    D_58: '58 (Nièvre)',
    D_59: '59 (Nord)',
    D_60: '60 (Oise)',
    D_61: '61 (Orne)',
    D_62: '62 (Pas-de-calais)',
    D_63: '63 (Puy-de-dôme)',
    D_64: '64 (Pyrénées-atlantiques)',
    D_65: '65 (Hautes-Pyrénées)',
    D_66: '66 (Pyrénées-orientales)',
    D_67: '67 (Bas-rhin)',
    D_68: '68 (Haut-rhin)',
    D_69: '69 (Rhône)',
    D_70: '70 (Haute-saône)',
    D_71: '71 (Saône-et-loire)',
    D_72: '72 (Sarthe)',
    D_73: '73 (Savoie)',
    D_74: '74 (Haute-savoie)',
    D_75: '75 (Paris)',
    D_76: '76 (Seine-maritime)',
    D_77: '77 (Seine-et-marne)',
    D_78: '78 (Yvelines)',
    D_79: '79 (Deux-sèvres)',
    D_80: '80 (Somme)',
    D_81: '81 (Tarn)',
    D_82: '82 (Tarn-et-Garonne)',
    D_83: '83 (Var)',
    D_84: '84 (Vaucluse)',
    D_85: '85 (Vendée)',
    D_86: '86 (Vienne)',
    D_87: '87 (Haute-vienne)',
    D_88: '88 (Vosges)',
    D_89: '89 (Yonne)',
    D_90: '90 (Territoire de belfort)',
    D_91: '91 (Essonne)',
    D_92: '92 (Hauts-de-seine)',
    D_93: '93 (Seine-Saint-Denis)',
    D_94: '94 (Val-de-marne)',
    D_95: "95 (Val-d'Oise)",
    D_971: '971 (Guadeloupe)',
    D_972: '972 (Martinique)',
    D_973: '973 (Guyane)',
    D_974: '974 (La réunion)',
    D_976: '976 (Mayotte)',
  };

  public static getIntitule(deps: string): string | undefined {
    return DepartementMapper.INTITULES[deps];
  }
}
